<template>
  <!-- 用能查询 -->
  <el-row class="peak-valley-analysis flex-grow-1" type="flex" :gutter="12">
    <!-- 右側 -->
    <el-col :span="24" class="d-flex flex-column">
      <!-- 條件查詢 -->
      <div class="selector-container section-container d-flex align-items-center"
       :class="{'dark':skinType}">
         <SectionTitle title="峰谷分析" ></SectionTitle>
        <el-form :inline="true" style="text-align: left" size="small">
          <period-date-selector
            :isDateSelector="selectNode&&selectNode.oType !== 'jx' && selectNode.oType !== 'cx'"
            @startEndDate="startEndDateListener"
          ></period-date-selector>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button  @click="exportTable">导出</el-button>
          </el-form-item>
        </el-form>
        <el-button style="margin-left:auto;" size="small"
          type="primary" circle icon="iconfont  iconfanhui"
          v-on:click="$router.go(-1)"></el-button>
      </div>
      <el-table  size="small"
        class="energy-table flex-grow-1 d-flex flex-column"
        :data="tableData"
        height="0"
        stripe
                style="width: 100%"
        ref="table"
        :class="{'dark':skinType}"
        :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
      >
        <el-table-column prop="PointName" label="监测点" width="120"> </el-table-column>
        <el-table-column prop="Total" label="总(kWh)"> </el-table-column>
        <el-table-column prop="Sharp" label="尖(kWh)"> </el-table-column>
        <el-table-column prop="Sharp_Rate" label="尖比重(%)"> </el-table-column>
        <el-table-column prop="Peak" label="峰(kWh)"> </el-table-column>
        <el-table-column prop="Peak_Rate" label="峰比重(%)"> </el-table-column>
        <el-table-column prop="Flat" label="平(kWh)"> </el-table-column>
        <el-table-column prop="Flat_Rate" label="平比重(%)"> </el-table-column>
        <el-table-column prop="Valley" label="谷(kWh)"> </el-table-column>
        <el-table-column prop="Valley_Rate" label="谷比重(%)">
        </el-table-column>
        <el-table-column prop="Date" label="监测日期" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.Date.split(" ")[0] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="d-flex section-container" :class="{'dark':skinType}" style="padding:1rem">
        <el-pagination
          v-if="pageInfo.total"
          style="margin-left: auto"
          :class="{'text-white':skinType}"
          background
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          :current-page.sync="pageIndex"
        >
        </el-pagination>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import PeriodDateSelector from '@/components/energy-analysis/components/period-date-selector.vue';
import { peakValleyAnalysis } from '@/api/statistic/statistic';
import { exportExcel } from '@/utils/utils';

export default {
  name: 'peak-valley-analysis',
  components: {
    PeriodDateSelector,
    SectionTitle,
  },
  data() {
    return {
      idstr: '',
      pageIndex: 1,
      startEndDate: null,
      selectNode: null,
      pageInfo: {
        index: 1,
        size: 10,
      },
      tableData: [],
      options: [
        {
          label: '上日',
          value: 0,
        },
        {
          label: '上周',
          value: 1,
        },
        {
          label: '上月',
          value: 2,
        },
        {
          label: '上年',
          value: 3,
        },
      ],
      compareDateType: 0,
      nodeList: [],
    };
  },
  watch: {
    pageIndex() {
      this.requestPeakValleyAnalysis();
    },
    startEndDate() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestPeakValleyAnalysis();
    },
  },
  mounted() {
    this.idstr = this.$route.params.id;
    this.requestPeakValleyAnalysis();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    nodeListChangeListener(list) {
      this.nodeList = list;
    },
    currentChangeListener(no) {
      this.pageIndex = no;
    },
    selectNodeListener(node) {
      this.selectNode = node;
    },
    startEndDateListener(datePeriod) {
      this.startEndDate = datePeriod;
    },
    requestPeakValleyAnalysis() {
      // if (this.startEndDate === null) {
      //   return;
      // }
      // if (this.selectNode === null) {
      //   return;
      // }
      peakValleyAnalysis({
        oType: 'hb',
        oIDstr: this.idstr,
        BeginDate: this.startEndDate.start,
        EndDate: this.startEndDate.end,
        page: this.pageIndex,
        rows: this.pageInfo.size,
      }).then((res) => {
        if (res !== null && res.list) {
          this.tableData = res.list;
          this.pageInfo.total = res.total;
          return;
        }
        this.tableData = res || [];
      }).catch(() => {
        this.tableData = [];
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onSubmit() {
      this.requestPeakValleyAnalysis();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
  },
};
</script>
<style scoped>
.breadcrumbs-contain {
  background-color: white;
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>
